<h2 mat-dialog-title>{{ tituloTxt }}</h2>
<mat-dialog-content>
  <form [formGroup]="registerForm" (ngSubmit)="guardar()" class="example-form">
    <input type="hidden" formControlName="id" value="">
    <br>
      <mat-form-field appearance="outline" class="example-full-width">
        <mat-label>Nombre completo</mat-label>
        <input formControlName="nombre" matInput placeholder="Nombre del usuario" value="">
        <mat-error>El nombre es requerido</mat-error>
      </mat-form-field>

        <mat-form-field appearance="outline" class="example-full-width">
          <mat-label>Tipo Documento</mat-label>
          <mat-select formControlName='tipoDocumento'>
            <mat-option *ngFor="let documento of documentos" [value]="documento.value">
              {{documento.nombre}}
            </mat-option>
          </mat-select>
          <mat-error>El tipo de documento es requerido</mat-error>
        </mat-form-field>

      <mat-form-field appearance="outline" class="example-full-width">
          <mat-label>Documento</mat-label>
          <input formControlName='documento' matInput placeholder="Documento del usuario" value="">
          <mat-error>Campo obligatorio y solo caracteres alfanuméricos</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="example-full-width">
          <mat-label>Email</mat-label>
          <input formControlName='email' matInput placeholder="Email del usuario" value="">
          <mat-error>{{getErrorMessageEmail()}}</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="example-full-width">
          <mat-label>Celular</mat-label>
          <input formControlName='celular' matInput placeholder="Número celular del usuario" value="">
          <mat-error>El celular es requerido</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="example-full-width">
          <mat-label>Dirección</mat-label>
          <input formControlName='direccion' matInput placeholder="Dirección del deportista" value="">
        </mat-form-field>

        <mat-form-field appearance="outline" class="example-full-width">
          <mat-label>Teléfono</mat-label>
          <input formControlName='telefono' matInput placeholder="telefono fijo o alternativo del deportista" value="">
        </mat-form-field>

        <mat-form-field appearance="outline" class="example-full-width">
          <mat-label>EPS</mat-label>
          <input formControlName='eps' matInput placeholder="EPS del deportista" value="">
          <mat-error>La eps es requerida</mat-error>
        </mat-form-field>

<!--         <mat-form-field appearance="outline" class="example-full-width">
          <mat-label>Fecha de nacimiento</mat-label>
          <input formControlName='fechaNacimiento' type="date" matInput placeholder="Fecha de nacimiento del deportista">
        </mat-form-field> -->
        <mat-form-field appearance="outline" class="example-full-width">
          <mat-label>Fecha de nacimiento</mat-label>
          <input matInput [matDatepicker]="picker" formControlName='fechaNacimiento' placeholder="dd/mm/aaaa">
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>


        <mat-form-field  appearance="outline" class="example-full-width">
          <mat-label>Tipo de sangre</mat-label>
          <mat-select formControlName='rh'>
            <mat-option disabled value=''>Sin datos</mat-option>
            <mat-option value='A+'>A+</mat-option>
            <mat-option value='A-'>A-</mat-option>
            <mat-option value='B+'>B+</mat-option>
            <mat-option value='B-'>B-</mat-option>
            <mat-option value='O+'>O+</mat-option>
            <mat-option value='O-'>O-</mat-option>
            <mat-option value='AB+'>AB+</mat-option>
            <mat-option value='AB-'>AB-</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field  appearance="outline" class="example-full-width">
          <mat-label>Sexo</mat-label>
          <mat-select formControlName='sexo'>
            <mat-option disabled value=''>Sin datos</mat-option>
            <mat-option value='0'>Femenino</mat-option>
            <mat-option value='1'>Masculino</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="example-full-width">  
          <mat-label>Nombre contacto Emergencia</mat-label>
          <input formControlName="contactoNombre" matInput placeholder="Nombre contacto de emergencia" value="">
        </mat-form-field>

<!--         <mat-form-field appearance="outline" class="example-full-width">
          <mat-label>Documento contacto Emergencia</mat-label>
          <input formControlName='contactoDocumento' matInput placeholder="Documento contacto de emergencia" value="">
        </mat-form-field> -->

        <mat-form-field appearance="outline" class="example-full-width">
          <mat-label>Teléfono contacto Emergencia</mat-label>
          <input formControlName='contactoTelefono' matInput placeholder="Telefono contacto de emergencia" value="">
        </mat-form-field>


<!--           <div class="example-full-width">
          <mat-slide-toggle class="example-margin" formControlName="estado">
            Estado
          </mat-slide-toggle>
        </div> -->
    </form>

</mat-dialog-content>
<mat-dialog-actions>
    <button type="submit" mat-button mat-flat-button color="primary" (click)='guardar()' [disabled]="registerForm.invalid">Guardar</button>
    <button mat-button mat-dialog-close='false' >Cancelar</button>
</mat-dialog-actions>
